import React, { Component, Fragment } from 'react';
import { Col, Table } from 'reactstrap';
import PropTypes from 'prop-types';

import './TableComidasPedidas.scss';

/**
* Tabla para mostrar de manera resumida las comidas en los pedidos de Viandas
* y los pedidos de Insumos.
*/
class TableComidasPedidas extends Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    static propTypes = {
        titulo: PropTypes.string.isRequired,
        // Debe incluir objetos con parametros: 'nombre' y 'cantidad'
        comidas: PropTypes.array.isRequired,
        /**
         * Agrega la columna Cantidad, que lee 'cantidad' de cada fila.
         *
         * Lo usan los insumos adjuntos al pedido de vianda: de un producto se
         * pueden pedir varias unidades, a diferencia de las comidas del menu
         * diario, donde cada una esta o no esta. El panel administrativo muestra
         * esa cantidad en su propia tabla "Insumos" (views/Pedidos/Modal.js).
         */
        conCantidad: PropTypes.bool,
    }

    render() {
        const {
            titulo,
            comidas,
            conCantidad,
        } = this.props;

        const columnas = conCantidad ? 2 : 1;

        return (
            <Fragment>
                <Col className="col-12 col-separator my-2 py-0 ml-md-1">
                    <span className="span-titulo">{titulo}</span>
                </Col>
                <Col className={'col-12'}>
                    <Table size="sm" striped>
                        <thead>
                            <tr>
                                <th className='col-nombre'>Nombre</th>
                                { conCantidad &&
                                    <th className='col-comida'>Cantidad</th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                comidas.map((comida, i) =>
                                    <tr key={i} className={'tr-comida'} >
                                        <td className='col-nombre'>{comida.nombre}</td>
                                        { conCantidad &&
                                            <td className='col-comida'>{comida.cantidad}</td>
                                        }
                                    </tr>
                                )
                            }
                            { comidas.length === 0 &&
                                <tr>
                                    <td className="text-center" colSpan={columnas}>No hay {titulo}.</td>
                                </tr>
                            }
                        </tbody>
                    </Table>
                </Col>
            </Fragment>
        );
    }
}

export default TableComidasPedidas;




// WEBPACK FOOTER //
// ./src/views/Viandas/HistorialViandas/TableComidasPedidas.js